var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon"},[_c('img',{style:(_vm.styles),attrs:{"src":_vm.iconUrl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }